import { ReactElement } from "react";
import HeaderItem from "./header_item";
import { menuItems ,menuItemsSeller} from "../../core/utils";
import logo from "../../assets/icons/logo-karamad2.png";
import { connect } from "react-redux";
interface IMyProps {
  userData?: any;

}

export function HeaderResponsive({userData}: IMyProps): ReactElement {
  const selectedMenuItems = userData?.is_saller === true ? menuItemsSeller : menuItems;

  return (
    <div className="header-responsive">
      <div className="w-100">
        <div className="header-responsive-headline">
          <img src={logo} alt="logo" width={"35px"} height={"35px"} />
          <span className="title" style={{ color: "#003366" }}>
            سامانه مشتریان
          </span>
        </div>
        {
        selectedMenuItems?.map((item, index) => (
            <HeaderItem
              key={index}
              name={item?.name}
              icon={item?.icon}
              link={item.path}
            />
          ))
        }
      </div>
    </div>
  );
}
const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(HeaderResponsive);
